import { flattenedRecipientCountryOptions } from '../../parcel-finder/claims/countries';
import { ClaimsCounts } from '../../../api/types';

export default function useRecipientCountryOptions(claimsCounts: ClaimsCounts) {
  const { recipientCountries } = claimsCounts;

  if (!recipientCountries) {
    return [];
  }

  const relevantCountries = flattenedRecipientCountryOptions
    .filter((country) => recipientCountries[country.value])
    .sort((a, b) => recipientCountries[b.value] - recipientCountries[a.value]);

  return relevantCountries.map((country) => {
    const count = recipientCountries[country.value] || 0;
    return {
      label: `${country.label} (${count})`,
      buttonLabel: `${country.label} (${count})`,
      value: country.value,
    };
  });
}
